import { Image } from '@petsmart-ui/sparky';
import privacyIcon from '../../svgs/privacyoptions.svg';

export function PrivacyIcon({
    size,
    alt = 'Privacy Icon',
}: Readonly<{
    size: number;
    alt?: string;
}>) {
    return (
        <Image
            data-testid="privacy-icon"
            src={privacyIcon}
            alt={alt}
            loading="lazy"
            width={size}
            height={size}
        />
    );
}
